export enum TicketStatus {
  Unknown,
  Unassigned = 1,
  Open = 2,
  AwaitingResponse = 3,
  OnHold = 4,
  Completed = 5,
}
